import { render } from "./MainFixedBottom.vue?vue&type=template&id=63af9974"
import script from "./MainFixedBottom.vue?vue&type=script&lang=js"
export * from "./MainFixedBottom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__